// Pure helper for partner subdomain routing.
// Given the current host, pathname, and search string, returns the target
// path the app should redirect to — or null when no redirect is needed.
//
// Rules:
//   - Only partner.* hosts are rewritten to the /partner portal.
//   - Requests already under /partner are left alone (no redirect loop).
//   - Token onboarding pages stay at /onboard/:token so email links work on
//     partner.whatfinland.com instead of being rewritten to a missing route.
//   - The pathname is preserved so deep links keep working
//     (e.g. partner.whatfinland.com/apply → /partner/apply).
//   - "/" maps to "/partner" (not "/partner/") to avoid trailing-slash loops.

export function isPartnerHost(host: string | null | undefined): boolean {
  if (!host) return false;
  const h = host.toLowerCase();
  return h === "partner.whatfinland.com" || h.startsWith("partner.");
}

export function resolvePartnerRedirect(
  host: string | null | undefined,
  pathname: string,
  search: string = "",
): string | null {
  if (!isPartnerHost(host)) return null;
  const lowerPathname = pathname.toLowerCase();
  if (lowerPathname === "/partner" || lowerPathname.startsWith("/partner/")) return null;
  if (lowerPathname === "/onboard" || lowerPathname.startsWith("/onboard/")) return null;
  // /profile is the consumer account page and must render as-is on the partner
  // subdomain too — the header account menu links here from every host.
  if (lowerPathname === "/profile" || lowerPathname.startsWith("/profile/")) return null;
  if (lowerPathname === "/onboarding" || lowerPathname.startsWith("/onboarding/")) {
    return "/partner/onboarding" + (search || "");
  }
  const suffix = pathname === "/" ? "" : pathname;
  return "/partner" + suffix + (search || "");
}
